<template>
    <div>
        <Navbar />
        <BuyNow />
        <MainBanner pathUrl="https://dryyazilim.com.tr/anaokulu/assets/data/get.php" />
        <AboutUs pathUrl="https://dryyazilim.com.tr/anaokulu/assets/data/get.php" />
        <BestServicesKids pathUrl="https://dryyazilim.com.tr/anaokulu/assets/data/get.php" />
        <TopSellingCourses pathUrl="https://dryyazilim.com.tr/anaokulu/assets/data/get.php" />
        <Feedback pathUrl="https://dryyazilim.com.tr/anaokulu/assets/data/get.php" />
        <KidsAges pathUrl="https://dryyazilim.com.tr/anaokulu/assets/data/get.php" />
        <OurUpcomingEvents pathUrl="https://dryyazilim.com.tr/anaokulu/assets/data/get.php" />
        <Blog pathUrl="https://dryyazilim.com.tr/anaokulu/assets/data/get.php" />
        <Subscribe pathUrl="https://dryyazilim.com.tr/anaokulu/assets/data/get.php" />
        <Footer />
    </div>
</template>

<script>
import Navbar from '../Layouts/Navbar'
import BuyNow from '../Layouts/BuyNow'
import MainBanner from '../Kindergaten/MainBanner'
import AboutUs from '../Kindergaten/AboutUs'
import BestServicesKids from '../Kindergaten/BestServicesKids'
import TopSellingCourses from '../Kindergaten/TopSellingCourses'
import Feedback from '../Kindergaten/Feedback'
import KidsAges from '../Kindergaten/KidsAges'
import OurUpcomingEvents from '../Kindergaten/OurUpcomingEvents'
import Blog from '../Kindergaten/Blog'
import Subscribe from '../Kindergaten/Subscribe'
import Footer from '../Layouts/Footer'

export default {
    name: 'KindergartenPage',
    metaInfo: {
        title: 'My Example App',
        titleTemplate: '%s - Yay!',
        htmlAttrs: {
            lang: 'tr',
            amp: true
        }
    },
    components: {
        Navbar,
        BuyNow,
        MainBanner,
        AboutUs,
        BestServicesKids,
        TopSellingCourses,
        Feedback,
        KidsAges,
        OurUpcomingEvents,
        Blog,
        Subscribe,
        Footer
    }
}
</script>